import React from 'react';
import { Box } from '@mui/material';
import { Stage } from '../api';
import { AttributeRenderers } from './types';
import clsx from 'clsx';

interface Props {
  stage: Stage;
  isLoading: boolean;
  attributeRenderers: AttributeRenderers;
}

export const StageAttributes = ({ stage, attributeRenderers, isLoading }: Props) => (
  <>
    {stage.stageFields.map((attribute, index) => (
      <Box className={clsx('attribute', isLoading && 'attribute-loading')} key={`${attribute.field}_${index}`}>
        {attributeRenderers[attribute.field] && attributeRenderers[attribute.field](attribute as any)}
      </Box>
    ))}
  </>
);
